var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_42896)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.52478,
    y: 0.788818,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_737_42896)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_737_42896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8728 14.0764H21.2369M21.2369 14.0764V20.4405M21.2369 14.0764L13.8119 21.5014",
    stroke: "white",
    strokeWidth: 1.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 1.02478,
    y: 1.28882,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_42896"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.52478,
    y: 0.788818,
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_737_42896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8.52478 8.78882)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_737_42896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8.52478 8.78882)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrow);
export default __webpack_public_path__ + "static/media/btn-arrow.898fbb96d3589441be168d946fd8f08a.svg";
export { ForwardRef as ReactComponent };